"use server"

import { cookies } from "next/headers"
import { revalidatePath } from "next/cache"

import { LANG_COOKIE, parseLang } from "./config"

/** Zapisuje wybór języka i odświeża bieżącą ścieżkę, żeby RSC przerenderowały się w nowym języku. */
export const setLang = async (value: string) => {
  const lang = parseLang(value)
  const store = await cookies()

  store.set(LANG_COOKIE, lang, {
    maxAge: 60 * 60 * 24 * 365,
    sameSite: "lax",
    path: "/",
    secure: process.env.NODE_ENV === "production",
  })

  revalidatePath("/", "layout")
}
